$(function() {
	$(window).scroll(function() {
		var elem = $('.product-item__image');
		elem.each(function () {
			var elemOffset = $(this).offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if(scrollPos > elemOffset - wh + (wh / 6) ){
			  $(this).addClass("active");
			}
		});

	});
  })